import { MouseEventHandler } from 'react';
import styled from 'styled-components';

import { theme } from '../../../../../common/ui/theme';
import { RfqOfferDetails } from '../../../components/RfqOfferCard/components/RfqOfferDetails';
import { RfqOfferPortAndTotals } from '../../../components/RfqOfferCard/components/RfqOfferPortAndTotals';

const RfqOfferSummaryContainer = styled.div`
    position: relative;
    cursor: pointer;
    padding: ${theme.space[16]};
`;

interface RfqOfferSummaryProps {
    onClick?: MouseEventHandler<HTMLDivElement>;
}

export const RfqOfferSummary = ({ onClick }: RfqOfferSummaryProps) => {
    return (
        <RfqOfferSummaryContainer onClick={onClick}>
            <RfqOfferPortAndTotals />
            <RfqOfferDetails />
        </RfqOfferSummaryContainer>
    );
};
